const isEmbed = (): boolean => {
  return window.location !== window.parent.location;
};

export default isEmbed;
